export enum WidgetType {
	EMPTY = 0,
	IMAGE = 1,
	IFRAME = 2
}
